<template>
  <v-layout class="common-container">
    <v-flex xs12>
      <v-layout row class="common-form-search mb-2 pt-3" style="position:relative">
        <v-flex md3>
          <!-- <v-select :items="myFeedback.typeOptions"
                    v-model="myFeedback.type"
                    outline
                    single-line
                    label="Type">

          </v-select> -->
          <v-select :items="myFeedback.typeOptions"
                      v-model="myFeedback.type"
                      outline
                      single-line
                      clearable
                      :menu-props="{contentClass:'feedback-type'}"
                      placeholder="Type">
          </v-select>
        </v-flex>
        <v-btn class="ml-4 red-button search-btn mt-0 text-none"
                @click="search()">search</v-btn>
        <v-btn class="ml-4 red-button search-btn mt-0 text-none" style="position: absolute; right: 0;" @click="feedBackClick()">Feedback</v-btn>
      </v-layout>
      <v-flex pt-4>
        <v-data-table :headers="myFeedback.headers"
                      :items="myFeedback.desserts"
                      hide-actions
                      :loading="myFeedback.loading"
                      no-data-text="No Data!"
                      class="common-table">
          <template slot="items"
                    slot-scope="props">
              <td style="position:relative">
                <span v-if="props.item.MessageStatus==2" class="spPos"></span>
                {{props.item.ID}}</td>
              <td>{{ props.item.Type }}</td>
              <td>{{ props.item.Objects}}</td>
              <td>{{ formaterTimes(props.item.CreateTime)}}</td>
              <td>{{ formaterStatus(props.item.Status) }}</td>
              <td>
                <v-tooltip bottom v-if="props.item.Details&&props.item.Details.length > 60" content-class="complaint-tooltip">
                  <template v-slot:activator="{ on }">
                    <v-btn flat
                       class="text-none pa-0 ma-0 detail-title"
                       @click="showReply(props.item.ID,props.item.CategoryCode,props.item.MessageStatus)" v-on="on">{{ props.item.Details | textTruncate(30) }}
                    </v-btn>
                  </template>
                  <span>{{ props.item.Details }}</span>
                </v-tooltip>

                <v-btn v-else flat
                  class="text-none pa-0 ma-0 detail-title"
                  @click="showReply(props.item.ID,props.item.CategoryCode,props.item.MessageStatus)">{{ props.item.Details }}
                </v-btn>
              </td>
              <td>
                  <v-btn v-if="props.item.FileUrl"
                      flat
                      icon
                      :href="props.item.FileUrl"
                      target="_blank">
                      <img :src="detailIcon"/>
                  </v-btn>
              </td>
              <!-- <td>
                  <v-btn small
                          class="text-none blue-button"
                          v-if="props.item.Status === 0"
                          @click="editMyFeedback(props.item.ID)">Edit</v-btn>
              </td> -->
          </template>
        </v-data-table>
        <div class="text-xs-left pt-2">
          <v-pagination v-model="myFeedback.pagination.pageIndex"
                        @input="search"
                        class="common-pagination"
                        :total-visible="myFeedback.pagination.totalVisible"
                        :length="myFeedback.pagination.totalPages"></v-pagination>
        </div>
        <template slot="no-data">
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-flex>
    </v-flex>
    <reply :reply="reply" />
  </v-layout>
</template>

<script>
import { getTeacherLateLeaveEarlyRecord } from '@/api/tutordata'
import { getFeedbackList, getReplyList,GetFeeBackType } from '@/api/feedBack.js'
import store from '@/store'
import { formatDate } from '@/utils/date'
import textTruncate from '@/filters/textTruncate'
import detailIcon from '../../assets/img/common/table-list-detail.png'
import reply from './reply'

export default {
  name: 'myFeedback',
  data: () => ({
    detailIcon: detailIcon,
    myFeedback: {
      loading: false,
      status: -1,
      type: -1,
    //   statusOption: [
    //     { text: 'Appealing', value: 0 },
    //     { text: 'Successful appeal', value: 1 },
    //     { text: 'Appeal failed', value: 2 }
    //   ],
      typeOptions: [
        // { text: 'Course Cut Payment', value: 1 },
        // { text: 'PAB', value: 2 },
        // { text:'Website issues',value:3},
        // { text:'Suggestion',value:4},
        // { text:'New Feature Suggestions',value:14,disabled:true},
        // { text:'Growth Center', value:18},
        // { text:'Other Features', value:19},
        // { text:'Service Fee Issues',value:1,disabled:true},
        // { text:'Service Fee Delay', value:21},
        // { text:'Service Fee Error', value:22},
        // { text:'Penalties',value:2,disabled:true},
        // {text:'Absence and Cancellation',value:24},
        // {text:'Late arrival and early leave',value:25},
        // {text:'Complaint',value:26},
        // {text:'Clock in',value:27},

        // { text:'Penalties',value:2,disabled:true},
        // {text:'Absence and Cancellation',value:24},
        // {text:'Late arrival and early leave',value:25},
        // {text:'Complaint',value:26},
        // {text:'Clock in',value:27},

        // { text:'System Errors',value:3,disabled:true},
        // { text:'A-Classroom',value:4},
        // { text:'IM',value:5},
        // { text:'TutorClient',value:6},
        // { text:"Tutor's System(Web)",value:7},
        // { text:"Acadsoc Teacher)",value:28},

        // { text:'Complaints against Students',value:8,disabled:true},
        // { text:'Not Taking Class Seriously',value:9},
        // { text:'Disrespect to the Teacher',value:10},
        // { text:'Complaint Manager',value:11},
        // { text:'Complaint Customer Service',value:12},
        // { text:'Textbook Error Corrections(from Class Table)',value:20},
        // { text:'Textbook Error Corrections',value:13},
        // { text:'Commendation',value:15},

        // { text:'Feedback',value:29,disabled:true},
        // { text:'Mangement',value:30},
        // { text:'Training',value:31},

        // { text:'Others',value:16},
        // { text:'APP Issues',value:17}
      ],
      headers: [
        {
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'ID'
        },
        {
          text: 'Type',
          align: 'left',
          sortable: false,
          value: 'Type'
        },
        {
          text: 'Objects',
          align: 'left',
          sortable: false,
          value: 'Objects'
        },
        {
          text: 'Creation Time',
          align: 'left',
          sortable: false,
          value: 'CreateTime'
        },
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'Status'
        },
        {
          text: 'Details',
          align: 'left',
          sortable: false,
          value: 'Details'
        },
        {
          text: 'Evidence',
          align: 'left',
          sortable: false,
          value: 'FileUrl'
        }
      ],
      desserts: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalVisible: 7,
        totalPages: 0
      },
    },
    reply:{
      dialog:false,
      id:0,
      status:'',
      items:[],
      code:0
    }
  }),
  components:{
    reply
  },
  created(){
    GetFeeBackType().then(res=>{
      if(res.data.Body&&res.data.Body.length>0){
        let arr=[]
        res.data.Body.forEach(item=>{
          let obj={}
          Object.keys(item).forEach((key,ind)=>{
          let val=key.replace(key[0],key[0].toLowerCase())
          obj[val]=item[key]
          })
          arr.push(obj)
        })
        this.myFeedback.typeOptions=arr
      }
    })
  },
  mounted () {
    this.search()
    // 进入页面数据埋点
    this.$store.dispatch('addTuModelClickLogFun',10)
  },
  computed: {
    feedbackDialogs () {
        return this.$store.state.layout.feedbackDialog
    },
  },
  methods: {
    feedBackClick(){
       let data = { dialog: true, id: '' }
      store.dispatch('setFeedbackDialog', data)
    },

    formaterType (e) {
      switch (e) {
        case 1: return 'Course Cut Payment'
        case 2: return 'PAB'
        case 3: return 'Website issues'
        case 4: return 'Suggestion'
      }
    },
    formaterStatus(e) {
        switch (e) {
          case 5:
          case 6:
            return 'Pending'
          case 7:
          case 8:
            return 'Processing'
          case 9: 
            return 'Solved'
          default:
            return ''
        }
    },
    formaterTime (e) {
      return formatDate(e, 'MM-dd-yyyy hh:mm')
    },
    formaterTimes (e) { 
      return formatDate(e, 'MM-dd-yyyy hh:mm:ss')
    },
    search () {
        this.myFeedback.loading = true
        var param = {
            Type: this.myFeedback.type,
            // Status: this.myFeedback.status,
            PageIndex: this.myFeedback.pagination.pageIndex ,
            PageSize: this.myFeedback.pagination.pageSize
        }
        // if (this.myFeedback.status) {
        //     param.Status = 0
        //     param.Status = this.myFeedback.status
        // }
        getFeedbackList(param).then(res => {
            this.myFeedback.desserts = []
            this.myFeedback.desserts = res.data.Body.Items
            let pages = res.data.Body.PageSize ? Math.ceil(res.data.Body.TotalPages / res.data.Body.PageSize) : 0
            this.myFeedback.pagination.totalPages = pages
        }).finally(() => {
          this.myFeedback.loading = false
        })
    },
    formatDate (date) {
      return formatDate(date, 'MM-dd-yyyy')
    },
    // editMyFeedback(id){
    //     let data = { dialog: true, id: id }
    //     store.dispatch('setFeedbackDialog', data)
        
    // },
    showReply (id,code,status) {
      getReplyList(id).then(res=>{
      if(res.data.ErrorCode===0&&res.data.Body){
          this.myFeedback.desserts.forEach((item,index)=>{
            if (item.ID==id) {
              item.MessageStatus=1
            }
          })
          this.reply.id = id
          this.reply.status = res.data.Body.Status
          this.reply.items = res.data.Body.ReplyList
          this.reply.code = code
          this.reply.dialog = true
          this.reply.msgStatus=status
        }
      })
    }
  },
  filters: { textTruncate },
  watch: {
      'feedbackDialogs.dialog': {
            handler:function(value) {   
                if(value == false){
                    this.search()
                }
            },
            deep: true
        }
  }
}
</script>
<style lang="scss" scoped>
.spPos{
  position: absolute;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: red;
  top: 50%;
  left: 10px;
  margin-top: -3px;
}
  .complaint-tooltip{
    width:500px;
    word-break: break-all;
    font-size: 14px;
    line-height: 24px;
    background: rgb(176, 179, 200);
    padding: 12px 15px;
  }
  .detail-title{
    color: $blue-title-2;
  }
</style>
<style lang="scss" >
.feedback-type.v-menu__content .v-select-list div[role=list] div[role=listitem]{
  margin-left:20px!important;
}
.feedback-type.v-menu__content .v-select-list div[role=list] div[disabled=disabled]{
  margin-left:0!important;
}
</style>
